import useSWR from 'swr'
import {useToken} from "../../../../app/hooks";
import API from "../../../../utils/api";
import {useEffect} from "react";


const M_KEY = '/board/notice/list' // 광고상세조회

const fetchKey = (id) =>
	`${M_KEY}/${id}`;

export function useHomeNoticeInfo(id) {
	const { data: token } = useToken();

	const KEY = fetchKey(id);


	const fetcher = () => fetchAPI(KEY, token ?? '');
	const { data, mutate } = useSWR(`${KEY}`, fetcher, { revalidateOnFocus: true });

	return { homeNoticeInfo: data, mutateHomeNoticeInfo: mutate};
}

async function fetchAPI(KEY:string, token: string)  {
	try {
		const response = await API.get(`${KEY}`, token, {});
		return response.result?.result;
	} catch (error) {
		console.error('Failed to fetch Home Notice Info:', error);
		return { list: [], total: 0 };
	}
}